import { useCallback } from 'react';
import useGameContext from '~/client/components/Game/context/Game/useGameContext';
import useIsLoggedIn from '~/client/hooks/user/useIsLoggedIn';
import { useClappForGameMutation } from './ClappForGameMutation.generated';
import {
  ClappsFragment,
  MyClappsFragment,
  useClappsQuery,
} from './ClappsQuery.generated';
import onClappForGame from './helpers/onClappForGame';

const useGameClapps = () => {
  const { game } = useGameContext();
  const isLoggedIn = useIsLoggedIn();
  const [clappForGame, { loading }] = useClappForGameMutation();
  const gameId = game?.id ?? '';
  const { data } = useClappsQuery({ variables: { gameId, isLoggedIn } });
  const { myClapps, allClapps } = data?.casino ?? {};
  const myRating = myClapps?.myRating;
  const isLiked = myRating === 'LIKE';

  const toggleClapp = useCallback(async () => {
    const success = await onClappForGame({
      gameId,
      clappForGame,
      rating: isLiked ? undefined : 'LIKE',
      myPreviousClapps: myClapps ?? ({} as MyClappsFragment),
      previousAllClapps: allClapps ?? ({} as ClappsFragment),
    });
    return { success };
  }, [allClapps, isLiked, myClapps, clappForGame, gameId]);

  return { isLiked, allClapps, toggleClapp, loading };
};

export default useGameClapps;
